// JavaScript files are compiled and minified during the build process to the assets/built folder. See available scripts in the package.json file.

// Import CSS
//import "../css/index.css";

// Import JS
import infiniteScroll from "./infiniteScroll";
import menuOpen from "./menuOpen";
import { newsletter } from "./newsletter";
import groupVeilleByMonth from "./groupVeilleByMonth";
import initVeilleArchive from "./veilleArchive";

[menuOpen, infiniteScroll, newsletter, groupVeilleByMonth, initVeilleArchive].forEach((init) => {
    try {
        init();
    } catch (error) {
        console.error(error);
    }
});
